import React from 'react';
import { FiCheckCircle, FiClock, FiLoader, FiFilter } from 'react-icons/fi';

// Review progress of an assessment, derived from questionnaire answer counts
// (see utils/assessmentStatus). Same three buckets as the dashboard summary cards.
export const STATUS_STYLES = {
  'Pending': 'bg-[#919191]/10 text-[#919191] border border-[#919191]/30',
  'Processing': 'bg-[#F47F2E]/10 text-[#F47F2E] border border-[#F47F2E]/30',
  'Completed': 'bg-[#0077b5]/10 text-[#0077b5] border border-[#0077b5]/30',
};

export const STATUS_ICONS = {
  'Completed': FiCheckCircle,
  'Processing': FiLoader,
  'Pending': FiClock,
};

export const STATUS_FILTERS = ['All', 'Completed', 'Processing', 'Pending'];

// Fixed-width pill so every badge in a table column lines up
const AssessmentStatusBadge = ({ status }) => {
  const label = STATUS_STYLES[status] ? status : 'Pending';
  const Icon = STATUS_ICONS[label];
  return (
    <span
      className={`inline-flex items-center justify-center gap-1.5 w-[104px] px-2 py-1 rounded-full text-[11px] font-semibold leading-none ${STATUS_STYLES[label]}`}
    >
      <Icon className="text-[13px] flex-shrink-0" />
      <span>{label}</span>
    </span>
  );
};

// Pill group for filtering a table by assessment status. When `counts` is supplied
// (option -> number), each pill shows how many rows it would match instead of an icon.
export const AssessmentStatusFilter = ({ value, onChange, label = 'Review Status', counts }) => (
  <div className="flex items-center gap-1.5 min-w-0">
    <span
      className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wide text-[#53545a] flex-shrink-0"
      title={label}
    >
      <FiFilter className="text-[#919191] text-xs flex-shrink-0" />
      <span className="whitespace-nowrap">{label}</span>
    </span>
    <span className="h-3.5 w-px bg-[#919191]/30 flex-shrink-0" aria-hidden="true" />
    <div className="flex items-center gap-1">
      {STATUS_FILTERS.map(option => {
        const active = value === option;
        const Icon = STATUS_ICONS[option];
        return (
          <button
            key={option}
            type="button"
            onClick={() => onChange(option)}
            title={option}
            className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-[10px] font-semibold border transition-colors whitespace-nowrap flex-shrink-0 ${
              active
                ? 'bg-[#0077b5] text-[#ffffff] border-[#0077b5]'
                : 'bg-[#ffffff] text-[#919191] border-[#919191]/30 hover:text-[#53545a] hover:border-[#919191]/60'
            }`}
          >
            {counts ? (
              <span
                className={`inline-flex items-center justify-center min-w-[16px] px-0.5 rounded-full text-[10px] font-bold leading-[14px] ${
                  active ? 'bg-[#ffffff]/25 text-[#ffffff]' : 'bg-[#919191]/15 text-[#53545a]'
                }`}
              >
                {counts[option] || 0}
              </span>
            ) : (
              Icon && <Icon className="text-[12px]" />
            )}
            {option}
          </button>
        );
      })}
    </div>
  </div>
);

export default AssessmentStatusBadge;
